import React, { useEffect, useRef, FC } from 'react';
import machine_app_state from '../../machine_app/models/machine_app_state';
import { MachineAppDefinitionCard } from "./MachineAppDefinitionCard";
import { gMachineAppViews } from "../../machine_app/machine_app_global_variables";

interface MachineAppProps {
  openMachineApp: (pType: string, pView: string) => void;
}
/**
 * This is a section of machine apps
 * @param param
 * @param param.navigationProps - used to open a machine app
 * @returns - a section of machine apps
 */
export const MachineAppSection: FC<MachineAppProps> = ({ openMachineApp }) => {

  const appDefinitionCardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // used to append jQuery to a react component.
    // I don't want to go down this rabbit hole, but it's a solution for now.
    const lLibraryManager = machine_app_state.getLibraryManager();
    const lAppDefinitionCards = machine_app_state
      .getImplementationManager()
      .listMachineAppDefinitions()
      .filter(pDefinition => pDefinition.getIsAvailable())
      .map(pAvailableDefinition => {
        const lOpenMachineApp = () => openMachineApp(pAvailableDefinition.getType(), gMachineAppViews.application);
        return MachineAppDefinitionCard(lOpenMachineApp, lLibraryManager, pAvailableDefinition);
      });

    lAppDefinitionCards.forEach(pAppDefinitionCard => {
      if(appDefinitionCardRef && appDefinitionCardRef.current){
        appDefinitionCardRef.current?.appendChild(pAppDefinitionCard[0]);
      }
    });

    return () => {
      lAppDefinitionCards.forEach(pAppDefinitionCard => {
        $(pAppDefinitionCard).remove();
      });
    };
  },[]);

  return (
    <div className='ml_application_landing_page_machine_app_card_container' ref={appDefinitionCardRef} ></div>
  );
};
